import { render } from "./CButton.vue?vue&type=template&id=13ca15b6&scoped=true"
import script from "./CButton.vue?vue&type=script&lang=js"
export * from "./CButton.vue?vue&type=script&lang=js"

import "./CButton.vue?vue&type=style&index=0&id=13ca15b6&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ca15b6"]])

export default __exports__